var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('keep-alive', [_vm.$route.meta.keepAlive ? _c('router-view') : _vm._e()], 1), !_vm.$route.meta.keepAlive ? _c('router-view') : _vm._e(), _c('Popup', {
    attrs: {
      "position": "center",
      "container-style": {
        'background-color': 'transparent'
      },
      "modal": true
    },
    model: {
      value: _vm.indicatorVisible,
      callback: function callback($$v) {
        _vm.indicatorVisible = $$v;
      },
      expression: "indicatorVisible"
    }
  }, [_c('div', {
    staticClass: "ro-indicator-wrap dark"
  }, [_c('div', {
    staticClass: "ro-indicator"
  }, [_vm.errorCount > 0 ? _c('span', {
    staticClass: "error-hint"
  }, [_c('i', {
    staticClass: "error-icon icon",
    domProps: {
      "innerHTML": _vm._s(_vm.errorInfo.icon)
    }
  }), _c('div', {
    staticClass: "error-label"
  }, [_vm._v(_vm._s(_vm.errorInfo.text))])]) : _c('DaisySpinner', {
    staticClass: "normal light"
  })], 1)])]), _c('QrcodePopup'), _c('Popup', {
    attrs: {
      "modal": _vm.district.modal
    },
    model: {
      value: _vm.district.visible,
      callback: function callback($$v) {
        _vm.$set(_vm.district, "visible", $$v);
      },
      expression: "district.visible"
    }
  }, [_c('DistrictPicker', {
    attrs: {
      "max-level": _vm.district.maxLevel,
      "level2": _vm.district.level2
    },
    on: {
      "update": _vm.onDistrictUpdate,
      "finish": _vm.onDistrictFinish
    }
  })], 1), _c('van-dialog', {
    attrs: {
      "show-confirm-button": false,
      "className": "change-package-dialog"
    },
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c('van-icon', {
    attrs: {
      "name": "close"
    },
    on: {
      "click": function click($event) {
        _vm.show = false;
      }
    }
  }), _c('img', {
    staticClass: "change-package-dialog-img",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "src": require("@/assets/images/qyp4.jpg"),
      "alt": "契约跑4推荐升级套餐弹窗"
    },
    on: {
      "click": _vm.onClickChangePackage
    }
  })], 1), _c('van-dialog', {
    attrs: {
      "show-confirm-button": false,
      "className": "change-package-dialog"
    },
    model: {
      value: _vm.show1,
      callback: function callback($$v) {
        _vm.show1 = $$v;
      },
      expression: "show1"
    }
  }, [_c('van-icon', {
    attrs: {
      "name": "close"
    },
    on: {
      "click": function click($event) {
        _vm.show1 = false;
      }
    }
  }), _c('img', {
    staticClass: "change-package-dialog-img",
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "src": _vm.show1Option.image
    },
    on: {
      "click": _vm.onClickChangePackage1
    }
  })], 1), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.topVisiable ? _c('img', {
    staticClass: "top-buton",
    attrs: {
      "src": require("./assets/images/index/top.png")
    },
    on: {
      "click": _vm.onClickGoTop
    }
  }) : _vm._e()]), _c('WechatPopup')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };